export enum ModifierKey {
  Alt,
  Control,
  Shift,
  Meta,
}
